import { TENANT_TYPES } from '../config/tenantConfig';

export const PLATFORMS = {
  HALIFLOW: 'haliflow',
  HALITRADE: 'halitrade'
};

export const USER_TYPES = {
  CUSTOMER: 'customer',
  AGENT: 'agent',
  PLATFORM: 'platform',
  BUYER: 'buyer'
};

export const SUB_ROLES = {
  ADMIN: 'admin',
  LEGAL: 'legal',
  RISK: 'risk',
  COMPLIANCE: 'compliance',
  OPERATIONS: 'operations'
};

export const SIDEBAR_ITEM_KEYS = {
  // Core
  DASHBOARD: 'dashboard',
  SETTINGS: 'settings',

  // Customer-specific
  MESSAGES: 'messages',
  INVOICE_FINANCING: 'invoiceFinancing',
  MY_SUBMISSIONS: 'mySubmissions',
  MY_TERMSHEETS: 'myTermsheets',
  MY_CONTRACTS: 'myContracts',
  MY_COMPANIES: 'myCompanies',
  MY_COMPANY: 'myCompany',
  TRADE_PARTNERS: 'tradePartners',
  VALIDATION_STATUS: 'validationStatus',
  ONBOARDING_CHOICE: 'onboardingChoice',

  // Platform-specific
  FINANCING_HUB_ADMIN: 'financingHubAdmin',
  FACTOR_TOOLS: 'factorTools',
  VALIDATION_QUEUE: 'validationQueue',
  SENT_TERMSHEETS: 'sentTermsheets',
  REFERRALS: 'referrals',
  CUSTOMER_CHAT: 'customerChat',
  COMPANIES: 'companies',
  REVIEW_LIST: 'reviewList',
  ANALYTICS_HUB: 'analyticsHub',
  TERMSHEETS_ANALYTICS: 'termsheetsAnalytics',
  CREDIT_LIMIT: 'creditLimit',
  FINANCED_DEALS: 'financedDeals',
  AUM_OVERVIEW: 'aumOverview',
  OPPORTUNITIES: 'opportunities',
  DATA_EXPLORER: 'dataExplorer',
  DATA_EXPLORER: 'dataExplorer',
  USER_MANAGEMENT: 'userManagement',
  MARKETPLACE: 'marketplace',
  INVOICE_DETAIL: 'invoiceDetail',
  FINANCE_TEAM: 'financeTeam',
  FUNDER_PROFILE: 'funderProfile',

  // Legacy/shared
  INVOICES: 'invoices',
  PAST_TRADES: 'pastTrades',
  BUYERS: 'buyers',
  SUPPLIERS: 'suppliers',
  AGENTS: 'agents',
  RISK_ANALYSIS: 'riskAnalysis',
  COMPLIANCE_CHECKS: 'complianceChecks',
  LEGAL_DOCS: 'legalDocs',
  OPERATIONS: 'operations'
};

const buildSet = (items = []) => new Set(items);

const allKeys = Object.values(SIDEBAR_ITEM_KEYS);

export const sidebarPermissions = {
  [PLATFORMS.HALIFLOW]: {
    [USER_TYPES.CUSTOMER]: buildSet([
      SIDEBAR_ITEM_KEYS.DASHBOARD,
      SIDEBAR_ITEM_KEYS.MESSAGES,
      SIDEBAR_ITEM_KEYS.INVOICE_FINANCING,
      SIDEBAR_ITEM_KEYS.MARKETPLACE,
      SIDEBAR_ITEM_KEYS.INVOICE_DETAIL,
      SIDEBAR_ITEM_KEYS.MY_SUBMISSIONS,
      SIDEBAR_ITEM_KEYS.MY_TERMSHEETS,
      SIDEBAR_ITEM_KEYS.MY_CONTRACTS,
      SIDEBAR_ITEM_KEYS.MY_COMPANIES,
      SIDEBAR_ITEM_KEYS.MY_COMPANY,
      SIDEBAR_ITEM_KEYS.TRADE_PARTNERS,
      SIDEBAR_ITEM_KEYS.VALIDATION_STATUS,
      SIDEBAR_ITEM_KEYS.VALIDATION_STATUS,
      SIDEBAR_ITEM_KEYS.ONBOARDING_CHOICE
    ]),
    [USER_TYPES.BUYER]: buildSet([
      SIDEBAR_ITEM_KEYS.DASHBOARD,
      SIDEBAR_ITEM_KEYS.MESSAGES,
      SIDEBAR_ITEM_KEYS.MARKETPLACE,
      SIDEBAR_ITEM_KEYS.INVOICE_DETAIL
    ]),
    [USER_TYPES.AGENT]: buildSet([
      SIDEBAR_ITEM_KEYS.DASHBOARD,
      SIDEBAR_ITEM_KEYS.SUPPLIERS,
      SIDEBAR_ITEM_KEYS.BUYERS,
      SIDEBAR_ITEM_KEYS.AGENTS
    ]),
    [USER_TYPES.PLATFORM]: {
      [SUB_ROLES.ADMIN]: buildSet(allKeys),
      [SUB_ROLES.LEGAL]: buildSet([
        SIDEBAR_ITEM_KEYS.DASHBOARD,
        SIDEBAR_ITEM_KEYS.LEGAL_DOCS,
        SIDEBAR_ITEM_KEYS.COMPLIANCE_CHECKS,
        SIDEBAR_ITEM_KEYS.REVIEW_LIST,
        SIDEBAR_ITEM_KEYS.COMPANIES
      ]),
      [SUB_ROLES.RISK]: buildSet([
        SIDEBAR_ITEM_KEYS.DASHBOARD,
        SIDEBAR_ITEM_KEYS.RISK_ANALYSIS,
        SIDEBAR_ITEM_KEYS.BUYERS,
        SIDEBAR_ITEM_KEYS.SUPPLIERS,
        SIDEBAR_ITEM_KEYS.COMPANIES,
        SIDEBAR_ITEM_KEYS.ANALYTICS_HUB,
        SIDEBAR_ITEM_KEYS.CREDIT_LIMIT
      ]),
      [SUB_ROLES.COMPLIANCE]: buildSet([
        SIDEBAR_ITEM_KEYS.DASHBOARD,
        SIDEBAR_ITEM_KEYS.COMPLIANCE_CHECKS,
        SIDEBAR_ITEM_KEYS.LEGAL_DOCS,
        SIDEBAR_ITEM_KEYS.VALIDATION_QUEUE,
        SIDEBAR_ITEM_KEYS.COMPANIES
      ]),
      [SUB_ROLES.OPERATIONS]: buildSet([
        SIDEBAR_ITEM_KEYS.DASHBOARD,
        SIDEBAR_ITEM_KEYS.OPERATIONS,
        SIDEBAR_ITEM_KEYS.VALIDATION_QUEUE,
        SIDEBAR_ITEM_KEYS.SENT_TERMSHEETS,
        SIDEBAR_ITEM_KEYS.COMPANIES,
        SIDEBAR_ITEM_KEYS.CUSTOMER_CHAT,
        SIDEBAR_ITEM_KEYS.INVOICES,
        SIDEBAR_ITEM_KEYS.PAST_TRADES
      ])
    }
  },
  [PLATFORMS.HALITRADE]: {
    [USER_TYPES.CUSTOMER]: buildSet([
      SIDEBAR_ITEM_KEYS.DASHBOARD,
      SIDEBAR_ITEM_KEYS.MESSAGES,
      SIDEBAR_ITEM_KEYS.INVOICE_FINANCING,
      SIDEBAR_ITEM_KEYS.MARKETPLACE,
      SIDEBAR_ITEM_KEYS.INVOICE_DETAIL,
      SIDEBAR_ITEM_KEYS.MY_SUBMISSIONS,
      SIDEBAR_ITEM_KEYS.MY_TERMSHEETS,
      SIDEBAR_ITEM_KEYS.MY_CONTRACTS,
      SIDEBAR_ITEM_KEYS.MY_COMPANIES,
      SIDEBAR_ITEM_KEYS.MY_COMPANY,
      SIDEBAR_ITEM_KEYS.TRADE_PARTNERS,
      SIDEBAR_ITEM_KEYS.VALIDATION_STATUS,
      SIDEBAR_ITEM_KEYS.ONBOARDING_CHOICE
    ]),
    [USER_TYPES.AGENT]: buildSet([
      SIDEBAR_ITEM_KEYS.DASHBOARD,
      SIDEBAR_ITEM_KEYS.SUPPLIERS,
      SIDEBAR_ITEM_KEYS.BUYERS,
      SIDEBAR_ITEM_KEYS.TRADE_PARTNERS,
      SIDEBAR_ITEM_KEYS.LEGAL_DOCS,
      SIDEBAR_ITEM_KEYS.MY_SUBMISSIONS,
      SIDEBAR_ITEM_KEYS.MY_TERMSHEETS,
      SIDEBAR_ITEM_KEYS.SETTINGS
    ]),
    [USER_TYPES.PLATFORM]: {
      [SUB_ROLES.ADMIN]: buildSet(allKeys),
      [SUB_ROLES.LEGAL]: buildSet([
        SIDEBAR_ITEM_KEYS.DASHBOARD,
        SIDEBAR_ITEM_KEYS.LEGAL_DOCS,
        SIDEBAR_ITEM_KEYS.COMPLIANCE_CHECKS
      ]),
      [SUB_ROLES.RISK]: buildSet([
        SIDEBAR_ITEM_KEYS.DASHBOARD,
        SIDEBAR_ITEM_KEYS.RISK_ANALYSIS,
        SIDEBAR_ITEM_KEYS.COMPANIES
      ]),
      [SUB_ROLES.COMPLIANCE]: buildSet([
        SIDEBAR_ITEM_KEYS.DASHBOARD,
        SIDEBAR_ITEM_KEYS.COMPLIANCE_CHECKS,
        SIDEBAR_ITEM_KEYS.LEGAL_DOCS
      ]),
      [SUB_ROLES.OPERATIONS]: buildSet([
        SIDEBAR_ITEM_KEYS.DASHBOARD,
        SIDEBAR_ITEM_KEYS.OPERATIONS,
        SIDEBAR_ITEM_KEYS.COMPANIES
      ])
    }
  }
};

const agentAliases = new Set(['agent', 'halitrade', 'halitrade_agent', 'halitrade-agent']);
const platformAliases = new Set(['platform', 'platform_user', 'platform_admin', 'platform-manager', 'platform_manager', 'halilab', 'halisoft']);
const customerAliases = new Set(['customer', 'client']);
const buyerAliases = new Set(['buyer', 'trade_partner', 'debtor']);

export const getPlatformFromTenant = (tenantType) => {
  if (tenantType === TENANT_TYPES.HALITRADE) return PLATFORMS.HALITRADE;
  if (tenantType === TENANT_TYPES.HALIFUND) return PLATFORMS.HALIFLOW;
  if (tenantType === TENANT_TYPES.HALILAB) return PLATFORMS.HALIFLOW;
  if (tenantType === TENANT_TYPES.PLATFORM || tenantType === TENANT_TYPES.CUSTOMER) {
    return PLATFORMS.HALIFLOW;
  }
  return PLATFORMS.HALIFLOW;
};

export const getUserType = (user = {}) => {
  if (!user) return USER_TYPES.CUSTOMER;
  const normalized = String(user.category || user.userType || user.role || '')
    .trim()
    .toLowerCase();

  if (customerAliases.has(normalized)) return USER_TYPES.CUSTOMER;
  if (agentAliases.has(normalized)) return USER_TYPES.AGENT;
  if (buyerAliases.has(normalized)) return USER_TYPES.BUYER;
  if (platformAliases.has(normalized) || normalized.includes('platform')) return USER_TYPES.PLATFORM;

  // SECURITY: do NOT derive user type from `user.tenant`. The tenant is
  // computed client-side from the URL path (detectTenant) and is therefore
  // attacker-controlled — visiting /platform/dashboard would otherwise
  // stamp tenant='platform' on any user and grant them platform admin.
  // Trust ONLY the persisted category/role/userType from the DB.

  return USER_TYPES.CUSTOMER;
};

export const getUserSubRole = (user = {}) => {
  if (!user) return SUB_ROLES.OPERATIONS;
  const normalized = String(user.role || '').trim().toLowerCase();
  if (!normalized) return SUB_ROLES.OPERATIONS;
  if (normalized.includes('legal')) return SUB_ROLES.LEGAL;
  if (normalized.includes('risk')) return SUB_ROLES.RISK;
  if (normalized.includes('compliance')) return SUB_ROLES.COMPLIANCE;
  if (normalized.includes('operation')) return SUB_ROLES.OPERATIONS;
  if (normalized.includes('admin')) return SUB_ROLES.ADMIN;
  // SECURITY: any unknown role (e.g. 'investor', 'customer', 'buyer') must
  // NOT default to ADMIN. ADMIN must be earned by either the literal
  // 'admin' role or by category being in platformAliases (in which case
  // isPlatformAdmin's userType check already runs). Default to the least
  // privileged sub-role.
  return SUB_ROLES.OPERATIONS;
};

export const canSeeSidebarItem = (user, platform, itemKey) => {
  if (!itemKey) return true;
  if (!platform) return false;
  const type = getUserType(user);
  if (!platform || !sidebarPermissions[platform]) return false;

  if (type !== USER_TYPES.PLATFORM) {
    const allowed = sidebarPermissions[platform][type];
    const result = Boolean(allowed && allowed.has(itemKey));
    // Debug only: console.log('[canSeeSidebarItem] Non-platform user', { platform, itemKey, type, result });
    return result;
  }

  const subRole = getUserSubRole(user);
  const platformMap = sidebarPermissions[platform][USER_TYPES.PLATFORM] || {};
  const allowed = platformMap[subRole];
  const result = Boolean(allowed && allowed.has(itemKey));
  // Debug only: console.log('[canSeeSidebarItem] Platform user', { platform, itemKey, type, subRole, result });
  return result;
};

export const isPlatformAdmin = (user) => {
  const userType = getUserType(user);
  const subRole = getUserSubRole(user);
  const result = userType === USER_TYPES.PLATFORM && subRole === SUB_ROLES.ADMIN;
  // Debug only: console.log('[isPlatformAdmin]', { userType, subRole, result });
  return result;
};

export const hasRequiredRole = (requiredRole, user, platform) => {
  if (!requiredRole) return true;
  if (requiredRole === 'platform-admin') {
    return isPlatformAdmin(user);
  }
  return false;
};
